/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sellers_Stats_ItemsInputs */

const id_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const ms_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Item`)
};

const da_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const de_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const en_us2_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const es_es2_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const es_mx2_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ítems`)
};

const fil_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Item`)
};

const fr_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const it_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Articoli`)
};

const hu_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemek`)
};

const nl_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items`)
};

const no_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementer`)
};

const pl_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elementy`)
};

const pt_br2_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const pt_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Itens`)
};

const ro_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente`)
};

const fi_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kohteet`)
};

const sv_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Objekt`)
};

const vi_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục`)
};

const tr_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öğeler`)
};

const cs_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Položky`)
};

const bg_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обекти`)
};

const ru_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Объектов`)
};

const uk_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Елементів`)
};

const ar_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العناصر`)
};

const hi_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आइटम`)
};

const th_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`รายการ`)
};

const ja_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`アイテム`)
};

const zh_cn2_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const zh_hant1_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`物品`)
};

const ko_sellers_stats_items = /** @type {(inputs: Sellers_Stats_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`아이템`)
};

/**
* | output |
* | --- |
* | "Items" |
*
* @param {Sellers_Stats_ItemsInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sellers_stats_items = /** @type {((inputs?: Sellers_Stats_ItemsInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sellers_Stats_ItemsInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sellers_stats_items(inputs)
	if (locale === "ms") return ms_sellers_stats_items(inputs)
	if (locale === "da") return da_sellers_stats_items(inputs)
	if (locale === "de") return de_sellers_stats_items(inputs)
	if (locale === "en-US") return en_us2_sellers_stats_items(inputs)
	if (locale === "es-ES") return es_es2_sellers_stats_items(inputs)
	if (locale === "es-MX") return es_mx2_sellers_stats_items(inputs)
	if (locale === "fil") return fil_sellers_stats_items(inputs)
	if (locale === "fr") return fr_sellers_stats_items(inputs)
	if (locale === "it") return it_sellers_stats_items(inputs)
	if (locale === "hu") return hu_sellers_stats_items(inputs)
	if (locale === "nl") return nl_sellers_stats_items(inputs)
	if (locale === "no") return no_sellers_stats_items(inputs)
	if (locale === "pl") return pl_sellers_stats_items(inputs)
	if (locale === "pt-BR") return pt_br2_sellers_stats_items(inputs)
	if (locale === "pt") return pt_sellers_stats_items(inputs)
	if (locale === "ro") return ro_sellers_stats_items(inputs)
	if (locale === "fi") return fi_sellers_stats_items(inputs)
	if (locale === "sv") return sv_sellers_stats_items(inputs)
	if (locale === "vi") return vi_sellers_stats_items(inputs)
	if (locale === "tr") return tr_sellers_stats_items(inputs)
	if (locale === "cs") return cs_sellers_stats_items(inputs)
	if (locale === "bg") return bg_sellers_stats_items(inputs)
	if (locale === "ru") return ru_sellers_stats_items(inputs)
	if (locale === "uk") return uk_sellers_stats_items(inputs)
	if (locale === "ar") return ar_sellers_stats_items(inputs)
	if (locale === "hi") return hi_sellers_stats_items(inputs)
	if (locale === "th") return th_sellers_stats_items(inputs)
	if (locale === "ja") return ja_sellers_stats_items(inputs)
	if (locale === "zh-CN") return zh_cn2_sellers_stats_items(inputs)
	if (locale === "zh-Hant") return zh_hant1_sellers_stats_items(inputs)
	return ko_sellers_stats_items(inputs)
});
export { sellers_stats_items as "sellers.stats.items" }